 
import { AnyAction } from "redux"
import { GET_ALL_CUSTOMER_SUBSCRIBERS_FAIL, GET_ALL_CUSTOMER_SUBSCRIBERS_REQ, GET_ALL_CUSTOMER_SUBSCRIBERS_SUCC } from "redux/actions/customerSubscriber/type"
 
  

interface State {
    loading?: boolean
    data?: any,
    error?: string,
     

}

const defaultState: State = {
    loading: false,
    data: [],
    

}

// export const GET_ALL_CUSTOMER_SUBSCRIBERS_REQ="GET_ALL_CUSTOMER_SUBSCRIBERS_REQ"
// export const GET_ALL_CUSTOMER_SUBSCRIBERS_SUCC="GET_ALL_CUSTOMER_SUBSCRIBERS_SUCC"
// export const GET_ALL_CUSTOMER_SUBSCRIBERS_FAIL="GET_ALL_CUSTOMER_SUBSCRIBERS_FAIL""

export const getSubscriberCustomersReducer = (state: State = defaultState, action: AnyAction) => {
    switch (action.type) {
        case GET_ALL_CUSTOMER_SUBSCRIBERS_REQ:

            return {
                loading: true,
                 data:[]
            }
        case GET_ALL_CUSTOMER_SUBSCRIBERS_SUCC:
            
            return {
                loading: false,
                data: action.payload,
                 
            }
        case GET_ALL_CUSTOMER_SUBSCRIBERS_FAIL:
            return {
                loading: false,
                error: action.payload
            }
 

        default:
            return state;
    }
}